(() => {
  'use strict';
  if (customElements.get('bie-product-promo')) return;
  const QUERY = `mutation BiePromoPreview($input: CartInput!) {
    cartCreate(input: $input) {
      cart { discountCodes { code applicable } lines(first: 10) { nodes {
        quantity cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } }
      } } }
      userErrors { field message }
    }
  }`;
  class ProductPromo extends HTMLElement {
    connectedCallback() {
      if(this.started)return;this.started=true;
      this.field=this.querySelector('input');this.status=this.querySelector('[data-status]');
      this.applyButton=this.querySelector('[data-apply]');this.removeButton=this.querySelector('[data-remove]');
      this.root=this.closest('product-info');this.activeCode='';this.serial=0;this.busy=false;
      this.applyButton.onclick=()=>this.apply();this.removeButton.onclick=()=>this.removeCode();
      this.field.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();this.apply();}});
      this.selectionKey=JSON.stringify(this.selection());
      this.onChange=e=>{if(e.target.name!=='id'&&e.target.name!=='quantity')return;let key;try{key=JSON.stringify(this.selection());}catch{key='invalid';}if(key===this.selectionKey)return;this.selectionKey=key;this.recalculate();};
      this.root.addEventListener('change',this.onChange);
      if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,e=>{if(e.data.sectionId===this.dataset.section)this.recalculate();});
      this.restore();
    }
    disconnectedCallback(){this.serial++;clearTimeout(this.timer);this.root?.removeEventListener('change',this.onChange);this.unsubscribe?.();this.clearPrice();}
    async request(path,body){
      const response=await fetch(path,{method:body?'POST':'GET',credentials:'same-origin',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined,signal:AbortSignal.timeout(15000)});
      if(!response.ok)throw Error('Shopify est temporairement indisponible. Réessayez.');
      return response.json();
    }
    route(path){return (window.Shopify?.routes?.root||'/')+path;}
    selection(){
      const form=document.getElementById(this.dataset.form),id=form?.elements.id?.value;
      const quantity=Number(form?.elements.quantity?.value||1);
      if(!/^\d+$/.test(id||'')||!Number.isInteger(quantity)||quantity<1||quantity>250)throw Error('Choisissez une variante et une quantité valide (maximum 250 pour cet aperçu).');
      return {merchandiseId:'gid://shopify/ProductVariant/'+id,quantity};
    }
    message(text,error=false){this.status.textContent=text;this.dataset.state=error?'error':'ok';}
    lock(value){this.busy=value;this.applyButton.disabled=value;this.removeButton.disabled=value;this.field.disabled=value;this.setAttribute('aria-busy',String(value));}
    clearPrice(){
      this.root?.querySelectorAll('.bie-promo-price').forEach(n=>n.remove());
      this.root?.querySelectorAll('.bie-promo-native-hidden').forEach(n=>n.classList.remove('bie-promo-native-hidden'));
      this.querySelector('[data-estimate]').hidden=true;this.querySelector('[data-estimate]').textContent='';
    }
    money(value,currency){return new Intl.NumberFormat(document.documentElement.lang||'fr-CA',{style:'currency',currency}).format(value);}
    async preview(code){
      const selection=this.selection();
      const result=await this.request('/api/2026-07/graphql.json',{query:QUERY,variables:{input:{lines:[selection],discountCodes:[code],buyerIdentity:{countryCode:this.dataset.country||'CA'}}}});
      const payload=result.data?.cartCreate;
      if(result.errors?.length||payload?.userErrors?.length||!payload?.cart)throw Error('Impossible de calculer ce code pour cette sélection. Vous pouvez le vérifier au paiement.');
      if(JSON.stringify(selection)!==JSON.stringify(this.selection()))return null;
      const cart=payload.cart,applicable=cart.discountCodes.some(c=>c.code.toUpperCase()===code.toUpperCase()&&c.applicable);
      const lines=cart.lines.nodes;
      if(!lines.length||lines.reduce((n,l)=>n+l.quantity,0)!==selection.quantity)throw Error('Quantité indisponible pour cet aperçu. Vérifiez votre sélection.');
      const currency=lines[0].cost.totalAmount.currencyCode;
      if(currency!==this.dataset.currency)throw Error('La devise de cet aperçu ne correspond pas à celle de la boutique. Vérifiez le code au paiement.');
      return {applicable,quantity:selection.quantity,currency,before:lines.reduce((n,l)=>n+Number(l.cost.subtotalAmount.amount),0),after:lines.reduce((n,l)=>n+Number(l.cost.totalAmount.amount),0)};
    }
    codes(cart){return [...new Set((cart.discount_codes||[]).map(c=>typeof c==='string'?c:c.code).filter(Boolean))];}
    async updateCode(code){
      const cart=await this.request(this.route('cart.js'));
      const codes=this.codes(cart).filter(c=>c.toUpperCase()!==this.activeCode.toUpperCase());
      if(code&&!codes.some(c=>c.toUpperCase()===code.toUpperCase()))codes.push(code);
      await this.request(this.route('cart/update.js'),{discount:codes.join(',')});
    }
    remember(){try{if(this.activeCode)sessionStorage.setItem('bie.promo.'+this.dataset.product,this.activeCode);else sessionStorage.removeItem('bie.promo.'+this.dataset.product);}catch{}}
    showPreview(p){
      this.clearPrice();if(!p)return;
      if(!p.applicable){this.message('Ce code ne s’applique pas à cette sélection. Vérifiez ses conditions au paiement.',true);return;}
      this.message('Code enregistré pour le panier. Shopify confirmera son application au paiement.');
      const total=this.querySelector('[data-estimate]');total.hidden=false;
      total.textContent='Total estimé pour '+p.quantity+' billet(s) : '+this.money(p.after,p.currency);
      if(p.after>=p.before)return;
      const container=document.getElementById('price-'+this.dataset.section);
      if(container){
        container.querySelectorAll('.price').forEach(n=>n.classList.add('bie-promo-native-hidden'));
        const price=document.createElement('div');price.className='bie-promo-price';
        const old=document.createElement('s');old.textContent=this.money(p.before/p.quantity,p.currency);
        const current=document.createElement('strong');current.textContent=this.money(p.after/p.quantity,p.currency);
        const note=document.createElement('small');note.textContent='Prix unitaire estimé avec le code promo';
        price.append(old,current,note);container.append(price);
      }
    }
    async apply(){
      if(this.busy)return;const code=this.field.value.trim();
      if(!code||code.length>100||code.includes(',')){this.message('Entrez un seul code promo.',true);return;}
      const version=++this.serial;this.lock(true);this.clearPrice();this.message('Vérification du code…');
      try{
        const p=await this.preview(code);if(version!==this.serial||!this.isConnected)return;
        if(!p){this.message('La sélection a changé. Cliquez de nouveau sur Appliquer.',true);return;}
        if(!p.applicable){this.message('Code invalide ou non applicable à cette variante et cette quantité. Certains codes exigent une identification au paiement.',true);return;}
        await this.updateCode(code);this.activeCode=code;this.remember();this.removeButton.hidden=false;
        if(version===this.serial)this.showPreview(p);
      }catch(e){this.message(e.message||'Vérification impossible. Réessayez.',true);}finally{this.lock(false);}
    }
    recalculate(){
      this.clearPrice();clearTimeout(this.timer);const version=++this.serial;
      if(!this.activeCode)return;this.message('Recalcul du prix…');
      this.timer=setTimeout(async()=>{if(this.busy){this.recalculate();return;}try{const p=await this.preview(this.activeCode);if(version===this.serial&&this.isConnected)this.showPreview(p);}catch(e){if(version===this.serial)this.message(e.message,true);}},450);
    }
    async removeCode(){
      if(this.busy)return;this.lock(true);++this.serial;clearTimeout(this.timer);
      try{await this.updateCode('');this.activeCode='';this.remember();this.field.value='';this.removeButton.hidden=true;this.clearPrice();this.message('Code retiré.');}catch(e){this.message(e.message,true);}finally{this.lock(false);}
    }
    async restore(){
      let saved='';try{saved=sessionStorage.getItem('bie.promo.'+this.dataset.product)||'';}catch{}
      if(!saved)return;
      try{const cart=await this.request(this.route('cart.js'));if(this.activeCode||this.busy||!this.isConnected)return;if(this.codes(cart).some(c=>c.toUpperCase()===saved.toUpperCase())){this.activeCode=saved;this.field.value=saved;this.removeButton.hidden=false;this.recalculate();}}catch{}
    }
  }
  customElements.define('bie-product-promo',ProductPromo);
})();
